import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import { useState } from "react";
import {
  selectLoading,
  setAssignPageGroupDialogOpen,
  setPageGroupDropDownDisable,
  setPageGroupForAssign,
  setRemoveButtonDisable,
  setSelectedAssignGroupPages,
} from "../../../../features/assetManagementSlice";
import { useSelector, useDispatch } from "react-redux";

export interface AssignPageGroupProps {
  // assignPageGroupDialogOpen: any;
  // setAssignPageGroupDialogOpen: any;
  // pageDetails: any;
  // pageGroups: any;
  // pageGroupForAssign: any;
  assignPageGroup: any;
  // setPageDetails: any;
  // setRefresh: any;
  // setIsCheckboxCheckedArray: any;
  // isCheckboxCheckedArray: any;
}

function AssignPageGroup({
  // isCheckboxCheckedArray,
  // setIsCheckboxCheckedArray,
  // setPageDetails,
  assignPageGroup,
}: // pageGroupForAssign,
// pageDetails,
// assignPageGroupDialogOpen,
// setAssignPageGroupDialogOpen,
AssignPageGroupProps) {
  const [selectPageGroup, setSelectPageGroup] = useState("");
  const loading = useSelector(selectLoading);
  // const pageGroupDialogOpen  = useSelector();
  //  const pageGroupDialogOpen = useSelector(
  //     (state :any) => state.assignPageGroup.assignPageGroupDialogOpen
  //   );
  const {
    assignPageGroupDialogOpen,
    pageGroupForAssign,
    removeButtonDisable,
    pageGroupDropDownDisable,
    selectedAssignGroupPages,
  } = useSelector((state: any) => state.assetManagement);

  const dispatch = useDispatch();
  /* Used in cancel */
  const handleClose = () => {
    dispatch(setAssignPageGroupDialogOpen(false));
    dispatch(setSelectedAssignGroupPages([]));
    dispatch(setPageGroupForAssign([]));

    // dispatch(setSelectedAssignGroupPages([]));
    // setAssignPageGroupDialogOpen(false);
  };
  const pageSharedUids = selectedAssignGroupPages.map(
    (item: any) => item?.shared_uid,
  );

  const assign = async () => {
    dispatch(setRemoveButtonDisable(true));
    dispatch(setPageGroupDropDownDisable(true));
    const data = {
      data: {
        page_group_id: `${selectPageGroup}`,
        pages_shared_uids: pageSharedUids,
      },
    };

    await assignPageGroup(data);
  };

  const handleRemove = (shared_uid: any, id: any) => {
    if (removeButtonDisable === true) return;
    const updatedRow = selectedAssignGroupPages.filter(
      (item: any) =>
        !(item.shared_uid === shared_uid && Number(item.id) === Number(id)),
    );
    if (updatedRow?.length > 0) {
      dispatch(setSelectedAssignGroupPages(updatedRow));
    } else {
      dispatch(setAssignPageGroupDialogOpen(false));
      dispatch(setSelectedAssignGroupPages([]));
    }
    // const iii = pageDetails.filter((item: any) => item.id === id);
    // setPageDetails(
    //   pageDetails.filter((item: any) => item.shared_uid !== shared_uid)
    // );
    // const updatedCheckboxState = [...isCheckboxCheckedArray];
    // updatedCheckboxState[iii[0]?.index] = !updatedCheckboxState[iii[0]?.index];
    // setIsCheckboxCheckedArray(updatedCheckboxState);
  };

  return (
    <div>
      {/* Dialog/popup after clicking on Assign page group button */}
      <Dialog open={assignPageGroupDialogOpen} fullWidth maxWidth="md">
        <div
          style={{
            padding: "16px 24px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            Assign Page Group
          </DialogTitle>
          {/* {selectedAssignGroupPages?.length > 0 ? (
            <> */}
          <DialogTitle sx={{ padding: "0px 0px 16px 0px", fontSize: "18px" }}>
            Selected Pages
          </DialogTitle>

          {/* table calling here */}
          <TableContainer component={Paper} sx={{ maxHeight: "180px" }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Current group</TableCell>
                  <TableCell>Remove</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedAssignGroupPages?.map((row: any, index: any) => (
                  <TableRow key={index}>
                    <TableCell sx={{ padding: "0 16px" }}>
                      {row.post_name}
                    </TableCell>
                    <TableCell sx={{ padding: "0 16px" }}>
                      {row.page_group_name}
                    </TableCell>
                    <TableCell sx={{ padding: "0 16px" }}>
                      <IconButton
                        sx={{
                          cursor: removeButtonDisable
                            ? "not-allowed"
                            : "pointer",
                          opacity: removeButtonDisable ? 0.4 : 1,
                          "&.Mui-disabled": {
                            opacity: 0.4,
                          },
                        }}
                        onClick={() => handleRemove(row?.shared_uid, row?.id)}
                        disabled={removeButtonDisable}
                        aria-label="delete"
                      >
                        <CancelOutlinedIcon color="secondary" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {/* DropDown for adding new page group */}
          <Autocomplete
            disabled={pageGroupDropDownDisable}
            options={pageGroupForAssign.filter(
              (pageGroup: any) => pageGroup?.active === true,
            )}
            getOptionLabel={(option: any) => option.group_name} // This determines what to display in the dropdown
            onChange={(_, value) =>
              setSelectPageGroup(value ? value.shared_uid : "")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="New Page Group"
                placeholder="Please select a page group from the list."
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start"></InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
            sx={{ paddingBlock: "24px 0" }}
          />
          <Typography
            sx={{
              paddingBlock: "8px 6px",
              fontSize: "12px",
              lineHeight: "20px",
              color: "#0000008F",
            }}
          >
            Can’t find the right group for these pages?
          </Typography>

          {/* if user can’t find the right group for pages then click on button below */}

          <Button
            sx={{ width: "250px", display: "flex", alignItems: "center" }}
            disabled
            variant="outlined"
            color="secondary"
          >
            CREATE NEW PAGE GROUP
            <LabelOutlinedIcon
              sx={{ marginLeft: "8px", marginBottom: "3px" }}
            />
          </Button>
          {/* </>
          ) : (
            <Typography
              variant="body1"
              align="center"
              sx={{ fontWeight: "normal" }}
            >
              No pages selected for assigning to a page group
            </Typography>
          )} */}
        </div>
        <DialogActions sx={{ padding: "0px 24px 20px 24px" }}>
          {/* if user wants to cancel then click on button below */}
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          {/* for assigning */}
          <Button
            disabled={
              !selectPageGroup?.length || !selectedAssignGroupPages?.length
            }
            onClick={assign}
            variant="contained"
            color="secondary"
            data-tracker="7"
            loading={loading}
          >
            ASSIGN
            <LabelOutlinedIcon sx={{ marginLeft: "5px" }} />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AssignPageGroup;
